import { Grid } from "@mui/material";

export const Mandatory2FAStepLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Grid container spacing={3} alignItems="center" sx={{ maxWidth: 484, alignItems: "flex-start" }}>
      {children}
    </Grid>
  );
};
